"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Accordion_1 = require("./Accordion");
const { root, heading } = Accordion_1.accordionClasses;
const MuiAccordionOverrides = {
    MuiAccordion: {
        styleOverrides: {
            root: ({ theme }) => ({
                [`&.${root}`]: {
                    boxShadow: 'none',
                    borderTop: `1px solid ${theme.palette.gray[300]}`,
                    borderLeft: `1px solid ${theme.palette.gray[300]}`,
                    borderRight: `1px solid ${theme.palette.gray[300]}`,
                },
                [`&.${root}:first-of-type`]: { borderTopLeftRadius: 2, borderTopRightRadius: 2 },
                [`&.${root}:last-of-type`]: {
                    borderBottomLeftRadius: 2,
                    borderBottomRightRadius: 2,
                    borderBottom: `1px solid ${theme.palette.gray[300]}`,
                },
                [`&.${root}:before`]: { backgroundColor: 'transparent' },
            }),
            heading: {
                [`&.${heading}`]: {
                    boxSizing: 'border-box',
                },
            },
        },
    },
};
exports.default = MuiAccordionOverrides;
//# sourceMappingURL=AccordionOverrides.js.map